/**
 * @generated SignedSource<<b5ca8aa8da88e288a3f0b9eb8e29db93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_groupResults$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_groupRow">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly firstGroup?: {
    readonly id: string;
    readonly issues: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraIssueEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow">;
  } | null | undefined;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_groupResults";
};
export type groupTableBody_nativeIssueTable_groupResults$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_groupResults">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "firstGroup",
          "issues"
        ]
      }
    ]
  },
  "name": "groupTableBody_nativeIssueTable_groupResults",
  "selections": [
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": "issues",
              "args": [
                {
                  "kind": "Variable",
                  "name": "fieldSetsInput",
                  "variableName": "fieldSetsInput"
                }
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "__firstGroupSection_nativeIssueTable__issues_connection",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "cursor"
                    },
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ]
                    }
                  ]
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "endCursor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isDensityFull",
                  "variableName": "isDensityFull"
                },
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                },
                {
                  "kind": "Variable",
                  "name": "isTimelineEnabled",
                  "variableName": "isTimelineEnabled"
                },
                {
                  "kind": "Variable",
                  "name": "projectKey",
                  "variableName": "projectKey"
                },
                {
                  "kind": "Variable",
                  "name": "projectKeys",
                  "variableName": "projectKeys"
                }
              ],
              "kind": "FragmentSpread",
              "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "groupRow_issueTableGrouping_groupRow"
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "e233a7c1e14962f59bde2d6a5530679f";

export default node;
